export default __webpack_public_path__ + "static/media/loc.fbe9d868.svg";